import React from 'react';
import { Link } from 'react-router-dom';
export const ConsumerCreditDisclosure = ({ config }) => {
  const d = config?.disclosures || {};
  return <div className="hl-disclosure" data-testid="consumer-credit-disclosure">
    {config?.mode === 'active' ? <>
      <p>{d.HOME_LOAN_COMPLIANCE_COPY}</p>
      <p>{d.CREDIT_REPRESENTATIVE_NAME} · Credit Representative {d.CREDIT_REPRESENTATIVE_NUMBER}<br />
        Authorised by {d.AUTHORIZING_LICENSEE_NAME} · Australian Credit Licence {d.AUSTRALIAN_CREDIT_LICENCE_NUMBER}</p>
      <p><Link to="/home-loans/credit-guide">Credit Guide</Link> · Complaints: <a href={`mailto:${d.HOME_LOAN_COMPLAINTS_EMAIL}`}>{d.HOME_LOAN_COMPLAINTS_EMAIL}</a><br />{d.AFCA_DETAILS}</p>
    </> : <p>The Home Loans pathway is being prepared. Credit assistance and home-loan enquiries are not currently available through this page. This information describes the intended process and is general in nature.</p>}
  </div>;
};
